// extracted by mini-css-extract-plugin
export default {"Strikethrough":"ReF2yWqx"};